import { AxiosRequestConfig, AxiosRequestHeaders } from 'axios'
const {
  REACT_APP_WC_STORE_CREDENTIALS,
  REACT_APP_WC_STORE_URL,
  REACT_APP_FETCH_API_URL,
  REACT_APP_FETCH_API_KEY,
  REACT_APP_WC_REST_API_CREDENTIALS,
  REACT_APP_WP_URL,
  REACT_APP_WP_CREDENTIALS,
} = process.env

const REQUEST_TIMEOUT = 30 * 1000

export const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
} as AxiosRequestHeaders

export const fetchCoreApiConfig = {
  headers: {
    ...defaultHeaders,
    'X-API-KEY': REACT_APP_FETCH_API_KEY,
    'Access-Control-Allow-Credentials': true,
  },
  baseURL: REACT_APP_FETCH_API_URL,
  timeout: REQUEST_TIMEOUT,
} as AxiosRequestConfig

export const WCStoreAPIConfig = {
  headers: {
    ...defaultHeaders,
    Authorization: `Basic ${REACT_APP_WC_STORE_CREDENTIALS}`,
  },
  baseURL: `${REACT_APP_WC_STORE_URL}/store`,
  timeout: REQUEST_TIMEOUT,
  credentials: 'include',
  withCredentials: true,
} as AxiosRequestConfig

export const WCRestAPIConfig = {
  headers: {
    ...defaultHeaders,
    Authorization: `Basic ${btoa(REACT_APP_WC_REST_API_CREDENTIALS)}`,
  },
  baseURL: `${REACT_APP_WC_STORE_URL}/v3`,
  timeout: REQUEST_TIMEOUT,
  credentials: 'include',
  withCredentials: true,
} as AxiosRequestConfig

export const WPRestAPIConfig = {
  headers: {
    ...defaultHeaders,
    Authorization: `Basic ${btoa(REACT_APP_WP_CREDENTIALS)}`,
  },
  baseURL: REACT_APP_WP_URL,
} as AxiosRequestConfig